import React from 'react';
import PropTypes from 'prop-types';
import { Label } from '@tfecom-thermofisher/react-komodo-design';

import { Message } from 'src/core/components';

import messages from '../../messages';

const PooledPlatesOrderingComponent = ({ orderedPlates }) => (
  <div>
    <Label className="dna-label">
      <Message message={messages.pooledPlates} />
    </Label>
    {orderedPlates.map((el) => (
      <div key={`${el.name}${el.plateList[0]}`}>
        {el.name}
        {' '}
        (
        {el.plateList[0]}
        {' '}
        /
        {el.plateList[1]}
        )
      </div>
    ))}
  </div>
);

PooledPlatesOrderingComponent.propTypes = {
  orderedPlates: PropTypes.array.isRequired,
};

export default PooledPlatesOrderingComponent;
